import { get } from "lodash";

function runAnalytics({ userEmail, window }) {
  const teamEmails = [
    "stephen.grable@broadlume.com",
    "alexa.hyde@broadlume.com",
    "matthew.jording@broadlume.com",
    "mark.feigen@broadlume.com"
  ];

  return (
    typeof window.analytics !== "undefined" &&
    teamEmails.indexOf(userEmail) === -1
  );
}

function extractFloorlytics(site) {
  const floorlytics = get(site, "floorlytics");
  const condition = get(floorlytics, "success", false);
  const messages = get(floorlytics, "warnings", ["No Message Available"]);

  return {
    condition,
    messages
  };
}

export { runAnalytics, extractFloorlytics };
